import fetchHandler from "../../utils/fetchHandler";
import { SESSION } from "../types/actions";

export const sendLoginCredentials = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/token-auth/`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_LOGIN_CREDENTIALS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const sendSubscribe = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/newsletter`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_SUBSCRIBE,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export function updateLoginCredentials(credentials, successHandler) {
	successHandler && successHandler();
	return {
		type: SESSION.UPDATE_LOGIN_CREDENTIALS,
		payload: credentials
	};
}

export function refreshToken(values, successHandler, errorHandler) {
	const fetchOptions = {
		url: `/api/token-refresh/`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_LOGIN_CREDENTIALS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
}

export function verifyToken(values, successHandler, errorHandler) {
	const fetchOptions = {
		url: `/api/token-verify/`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_LOGIN_CREDENTIALS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
}

export const sendForgotPasswordCredentials = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/password_reset/`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_FORGOT_PASSWORD_CREDENTIALS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const sendRegisterNowCredentials = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/members/`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_REGISTER_NOW_CREDENTIALS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const sendResetPasswordCredentials = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/change-password`,
		method: "POST",
		secure: false,
		actionType: SESSION.SEND_RESET_PASSWORD_CREDENTIALS,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};

export const requestInformationORScheduleAnAppointment = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/leads`,
		method: "POST",
		secure: false,
		actionType: SESSION.REQUEST_INFORMATION_OR_SCHEDULE_AN_APPOINTMENT,
		body: JSON.stringify(values)
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};
